import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabsComponent } from './tabs.component';
import { TabComponent } from './tab.component';
import { TabsRoutingModule } from './tabs.routing.module';

@NgModule({
  imports: [
    CommonModule,
    TabsRoutingModule
  ],
  exports: [
    TabsComponent,
    TabComponent
  ],
  declarations: [
    TabsComponent,
    TabComponent
  ]
})
export class TabsModule { }
